module.exports = __webpack_public_path__ + "img/viper.513e41e9.png";